<template>
  <div ref="pageView" class="pdfViewer"></div>
</template>

<style scoped lang="less">

</style>

<script>
const PDFJS = require("pdfjs-dist/legacy/build/pdf");
const PDFJSViewer = require("pdfjs-dist/legacy/web/pdf_viewer");

PDFJS.GlobalWorkerOptions.workerSrc = require("pdfjs-dist/legacy/build/pdf.worker.entry");

const USE_ONLY_CSS_ZOOM = true
const TEXT_LAYER_MODE = 0 // DISABLE

export default {
  name: "pdf-view",
  props: {
    eventBus: Object
  },
  mounted() {
    const pageView = this.$refs.pageView

    this.pdfViewer = new PDFJSViewer.PDFViewer({
      container: pageView.parentNode,
      viewer: pageView,
      eventBus: this.eventBus,
      removePageBorders: true,
      useOnlyCssZoom: USE_ONLY_CSS_ZOOM,
      textLayerMode: TEXT_LAYER_MODE
    })
  },
  methods: {
    load(file) {
      if (!file) return

      if (this.loadingTask) {
        return this.cancel().then(() => this.load(file))
      }

      const self = this
      const loadingTask = PDFJS.getDocument(file)

      this.loadingTask = loadingTask
      return loadingTask.promise.then(function(pdfDocument) {
        self.pdfViewer.setDocument(pdfDocument)
        return self.pdfViewer
      })
    },

    cancel() {
      console.log('pdf cancel...........')
      if (!this.loadingTask) {
        return Promise.resolve()
      }

      const promise = this.loadingTask.destroy()
      this.loadingTask = null
      this.pdfViewer.setDocument(null)

      return promise
    },
  }
}
</script>
